import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { ImageService } from 'src/app/services/image.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-consult-us',
    templateUrl: './consult-us.component.html',
    styleUrls: ['./consult-us.component.css']
})
export class ConsultUsComponent implements OnInit {

    errorMsg: any = [];
    sno = 1;
    showPopup = false;
    loading = false;
    ConsultUsList: any = [];
    branchname: any;
    Address :any;
    mobileno :any;
    maplink :any;
    editBannerId = '';
    modalBoxName;
    loadingBtn = false;
    viewBox = false;
    showImage = true;

    constructor(
        private apiService: ApiService,
        private toastr: ToastrService,
        private imageService: ImageService
    ) { }

    ngOnInit() {
        this.index();
    }

    index() {
        this.loading = true;
        this.apiService.index('getAllConsultUs').subscribe(data => {
            this.ConsultUsList = data.data;
            this.loading = false;
        });
    }

    store() {
        this.loadingBtn = true;
        this.apiCall('store', 'consultUs');
    }

    show(id) {
        this.apiService.show('consultUs/' + id).subscribe((data) => {
            const value = data.data;
            this.branchname = value.branch;
            this.Address = value.address;
            // this.mobileno = value.mobile_no;
            this.maplink = value.map_link;
            this.editBannerId = id;
        });
    }

    update(id) {
        this.loadingBtn = true;
        this.apiCall('update', 'consultUs/' + id);
    }

    destroy(id) {
        this.swalCall(id);
    }

    ConsultSwitch(id) {
        this.apiCall('getData', 'consultUsSwitch/' + id);
    }

    apiCall(name, url, value: any = '') {
        value = name === 'store' || name === 'update' ? {
            branch : this.branchname,
            address: this.Address,
            // mobile_no: this.mobileno,
            map_link: this.maplink,
        } : value;
        this.apiService[name](url, value).subscribe((data) => {
            if (data.error === false) {
                this.toastr.success(data.message);
                this.loadingBtn = false;
                this.popUpClose();
                this.index();
            } else {
                this.toastr.error(data.message);
                this.loadingBtn = false;
                this.errorMsg = data.data;
            }
        });
    }

    openModalBox(id = '') {
        if (id) {
            this.modalBoxName = 'Edit';
            this.show(id);
        } else {
            this.modalBoxName = 'Create';
        }
        this.showPopup = true;
    }

    popUpClose() {
        this.showPopup = false;
        this.branchname  = this.editBannerId = '';
        this.Address  = '';
        this.mobileno  = '';
        this.maplink  = '';
        this.errorMsg = [];
        this.viewBox = false;
    }

    keyPress(event, type, id = '') {
        if (event.keyCode === 13) {
            if (type === 'Create') {
                this.store();
            } else if (type === 'Edit') {
                this.update(id);
            }
        }
    }

    swalCall(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this data!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                this.apiCall('destroy', 'consultUs/' + id);
                Swal.fire(
                    'Deleted!',
                    'Your data has been deleted.',
                    'success'
                );
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire(
                    'Cancelled',
                    'Your data is safe.',
                    'error'
                );
            }
        });
    }
}
